import * as dayjs from 'dayjs'
import React, { useState } from 'react'
import { DownOutlined } from '@ant-design/icons'
import { Icon, useTraversal } from '@guillotinaweb/react-gmi'
import { Menu, Dropdown } from 'antd'

import NLPreview from '../views/newsletter_editor/Preview'
import { getFiltersByPath } from '../../utils'
import { useLocation } from 'wouter'

const color = {
  draft: 'is-light',
  scheduled: 'is-primary',
  verified: 'is-success',
}

function StatusTitle() {
  const Ctx = useTraversal()
  const [filters, setFilters] = useState(getFiltersByPath('/newsletters/'))
  const status = filters.map((s) => s.prefix?.status).find((v) => v)
  const [, navigate] = useLocation()

  function applyFilters(status) {
    return () => {
      const newFilters = status ? [{ prefix: { status } }] : []
      setFilters(newFilters)
      localStorage.setItem('filters:/newsletters/', JSON.stringify(newFilters))
      navigate('/?path=/newsletters/')
      Ctx.refresh()
    }
  }

  return (
    <>
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item onClick={applyFilters('draft')}>
              <div className={`tag ${color.draft}`}>draft</div>
            </Menu.Item>
            <Menu.Item onClick={applyFilters('verified')}>
              <div className={`tag ${color.verified}`}>verified</div>
            </Menu.Item>
            <Menu.Item onClick={applyFilters('scheduled')}>
              <div className={`tag ${color.scheduled}`}>scheduled</div>
            </Menu.Item>
            <Menu.Item onClick={applyFilters()}>
              <div>all status</div>
            </Menu.Item>
          </Menu>
        }
      >
        <div className="ant-dropdown-link" style={{ color: '#3298dc' }}>
          Status <DownOutlined />
        </div>
      </Dropdown>
      {status && <div className={`tag ${color[status]}`}>{status}</div>}
    </>
  )
}

export function getNLColumnHeadings([icon, , name]) {
  const status = {
    label: <StatusTitle />,
    child: (m, navigate) => {
      const s = m.item.status || 'draft'

      return (
        <td onClick={navigate} style={{ width: 110 }}>
          <span className={`tag ${color[s]}`}>{s}</span>
        </td>
      )
    },
  }

  const id = {
    label: 'Id',
    child: (m) => (
      <td style={{ width: 25 }}>
        <span className="tag">{m.id}</span>
      </td>
    ),
  }
  const scheduled_at = {
    label: 'Scheduled at',
    child: (m, navigate) => (
      <td onClick={navigate} style={{ width: 150 }}>
        <small>
          {dayjs(new Date(m.item.efective_date)).format('D/MM/YY - HH:mm')}
        </small>
      </td>
    ),
  }
  const preview = {
    label: '',
    child: (m) => (
      <td>
        <NLPreview
          key={m.id}
          id={m.id}
          label={<Icon icon="fas fa-eye" />}
          style={{
            fontSize: 12,
            marginTop: -3,
            borderRadius: '50%',
            backgroundColor: '#efefef',
          }}
        />
      </td>
    ),
  }
  const campaignName = { ...name, label: 'Campaign name' }

  return [icon, status, scheduled_at, campaignName, id, preview]
}
